import moment from "moment";
import { deepGet } from "./utility";

type StepType = {
  startDate: { min: number | undefined; max: number | undefined };
  endDate: { min: number | undefined; max: number | undefined };
};

export type MaxMinDatesType = {
  startMinDate: string | undefined;
  startMaxDate: string | undefined;
  endMinDate: string | undefined;
  endMaxDate: string | undefined;
  fixEndDate: boolean;
};

export const defaultMaxMinDates = {
  startMinDate: undefined,
  startMaxDate: undefined,
  endMinDate: undefined,
  endMaxDate: undefined,
  fixEndDate: false,
};

export function getMaxMinDates(startDate: string, step: StepType): MaxMinDatesType {
  const startDateMin = deepGet(step, "startDate.min") || 0;
  const startDateMax = deepGet(step, "startDate.max", 0);
  const addStartDateFormat = deepGet(step, "startDate.months", false) ? "months" : "days";

  const endDateMin = deepGet(step, "endDate.min");
  const endDateMax = deepGet(step, "endDate.max");
  const addEndDateFormat = deepGet(step, "endDate.months", false) ? "months" : "days";

  const fixEndDate = endDateMin !== undefined && endDateMin === endDateMax;

  // Los cálculos se hacen respecto al funcionamiento heredado del calendario (que suma un día siempre)
  // y a que la fecha que se va a mostrar en los endDates tiene que estar incluída (excepto en fixEndDate)
  // pero el back enviará a SENDA un día más porque SENDA no lo incluye
  const calculatedDates = {
    startMinDate: moment()
      .add(Number(startDateMin), addStartDateFormat)
      .add(-1, "days")
      .toISOString(),
    startMaxDate: moment().add(Number(startDateMax), addStartDateFormat).toISOString(),
    endMinDate: moment(startDate, "DD/MM/YYYY")
      .add(Number(endDateMin), addEndDateFormat)
      .add(fixEndDate ? 0 : -2, "days")
      .toISOString(),
    endMaxDate: moment(startDate, "DD/MM/YYYY")
      .add(Number(endDateMax), addEndDateFormat)
      .add(fixEndDate ? 0 : -1, "days")
      .toISOString(),
    fixEndDate,
  };

  return calculatedDates;
}

export function getHealthMaxMinDates(startDate: string, step: StepType): MaxMinDatesType {
  const startDateMin = deepGet(step, "startDate.min") || 0;
  const startDateMax = deepGet(step, "startDate.max", 0);
  const addStartDateFormat = deepGet(step, "startDate.months", false) ? "months" : "days";

  const endDateMin = deepGet(step, "endDate.min");
  const endDateMax = deepGet(step, "endDate.max");
  const addEndDateFormat = deepGet(step, "endDate.months", false) ? "months" : "days";

  const fixEndDate = endDateMin !== undefined && endDateMin === endDateMax;

  const calculatedDates = {
    startMinDate: moment().add(Number(startDateMin), addStartDateFormat).toISOString(),
    startMaxDate: moment().add(Number(startDateMax), addStartDateFormat).toISOString(),
    endMinDate: moment(startDate, "DD/MM/YYYY")
      // cuando no es fixDate el back envía 1 día más a SENDA por petición explícita
      // así que se le resta a la hora de mostrarlo en el front
      .add(Number(endDateMin), addEndDateFormat)
      .add(fixEndDate ? 0 : -1, "days")
      .toISOString(),
    endMaxDate: moment(startDate, "DD/MM/YYYY")
      .add(Number(endDateMax), addEndDateFormat)
      .add(fixEndDate ? 0 : -1, "days")
      .toISOString(),
    fixEndDate,
  };

  return calculatedDates;
}
